import { Ref, forwardRef } from 'react'

import styles from './Password.module.scss'
import Icon from '../../media/Icon'
import EyeIconSlash from '../../static/icons/eye-slash.svg?react'
import EyeIcon from '../../static/icons/eye.svg?react'
import Button from '../Button'
import { InputProps } from '../Input/input-types'
import { InputBase } from '../Input/InputBase'

function Password(props: InputProps, ref: Ref<HTMLInputElement>) {
    return (
        <InputBase
            ref={ref}
            {...props}
            type="password"
            adornmentRight={(attrs, setAttrs) => (
                <Button
                    className={styles.eyeButton}
                    name="togglePasswordVisibility"
                    category="customer.account.login.togglePasswordVisibility"
                    onClick={() =>
                        setAttrs({
                            type: attrs.type === 'text' ? 'password' : 'text',
                        })
                    }
                    variant="link"
                >
                    <Icon
                        component={
                            attrs.type === 'text' ? EyeIconSlash : EyeIcon
                        }
                        className={styles.icon}
                        title="Toggle password visibility"
                    ></Icon>
                </Button>
            )}
        />
    )
}
export const PasswordInput = forwardRef(Password)
